import React from 'react';
import {connect} from 'react-redux';

import Page from 'components/Page';
import {Container} from 'containers/types';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import VisibleIf from 'components/VisibleIf';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import {EmbeddedLookerDashboard} from './components';

import {openModalFromUrl} from 'utils/modals';
import {MODALS} from 'ducks/frontDesk';
import {openModal} from 'ducks/modals';

import './styles.css';

class LookerRevenueReporting extends React.Component<
  Container & LoginRequiredProps & typeof mapDispatchToProps
> {
  componentDidMount() {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {
        permission: PERMISSIONS.VIEW_LOOKER_DASHBOARD,
        locationRef
      },
      () => {
        openModalFromUrl(MODALS, this.props.openModal);
      }
    );
  }

  render() {
    const {locationRef} = this.props.match.params;
    return (
      <Page activeTab="LookerRevenueReporting" locationRef={locationRef}>
        <VisibleIf
          permission={PERMISSIONS.VIEW_LOOKER_DASHBOARD}
          locationRef={locationRef}>
          <div className="LookerRevenueReporting">
            <EmbeddedLookerDashboard locationRef={locationRef} />
          </div>
        </VisibleIf>
      </Page>
    );
  }
}

const mapDispatchToProps = {
  requiresPermission,
  openModal
};

export default connect(null, mapDispatchToProps)(
  LoginRequired(LookerRevenueReporting)
);
